import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/icons/warn.svg'
import _imports_1 from '../assets/icons/check_mark.svg'


const _hoisted_1 = { class: "payments-completed-container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "warn-mark"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: "check-mark"
}
const _hoisted_5 = {
  key: 2,
  style: {"margin-top":"16px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Loading, {
          key: 0,
          title: _ctx.t('verifying-payment'),
          fullscreen: ""
        }, null, 8, ["title"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.hasError)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
          _createElementVNode("h3", null, _toDisplayString(_ctx.getStatusTitle()), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.getStatusMessage()), 1),
          (_ctx.hasError && _ctx.paymentId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, "ID: " + _toDisplayString(_ctx.paymentId), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}